// Vendor
import * as React from 'react';
import { SPOT_BRAND } from '@thredup/styleguide/src/variables/colors';

// Internal
import { SVGProps } from './types';

/**
 * @name IconRecycle
 * @description Recyle Icon
 */
const IconRecycle: React.FC<SVGProps> = (props) => {
  const { className, desc, height, id, stroke, title, width } = props;

  return (
    <svg
      aria-labelledby={id}
      className={className}
      height={height}
      role="img"
      viewBox="0 0 87 87"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id={id}>{title}</title>
      <desc>{desc}</desc>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          transform="translate(-1110.000000, -300.000000)"
          stroke={stroke}
          strokeWidth="1.713"
        >
          <g id="Group-13" transform="translate(1111.000000, 301.000000)">
            <path
              d="M11.6183019,75.0705113 C15.7239633,78.2384964 26.0272501,82.5442237 26.0272501,82.5442237 L35.7793139,85 L40.9259259,69.3997173 L18.4644251,62.962963 C18.4644251,62.962963 10.7025784,74.3639017 11.6183019,75.0705113 Z"
              id="Stroke-1"
            ></path>
            <path
              d="M9.22835389,43.2337075 L8.04431766,38.4042586 C8.04431766,38.4042586 11.5385055,37.8436576 13.142468,37.2271084 C14.7453167,36.6116781 15.8669766,36.5725144 17.6291077,37.0726913 C19.3923526,37.5728683 20.6732949,38.6504307 20.6732949,38.6504307 C20.6732949,38.6504307 20.0751505,41.8282886 22.8353027,44.1479011 C25.5954549,46.4697515 28.6051124,45.3160996 28.6051124,45.3160996 C28.6051124,45.3160996 29.8860547,46.393662 30.6869221,48.0486098 C31.4877895,49.7035576 31.6470719,50.8202838 31.3262794,52.5132764 C31.0054869,54.207388 30.7782589,57.7153403 30.7782589,57.7153403 L26.131223,57.4423131 C26.131223,57.4423131 26.5600602,53.1454911 26.0120396,53.6602146 C23.9235468,55.6228775 13.1491512,68.838962 12.2925907,74.4964443 C12.2224173,74.9608144 0.788614913,58.6541512 0,57.0227016 C5.2919625,50.6714616 10.5505091,45.5712234 12.9553391,42.6842961 C12.4741503,43.2616816 9.22835389,43.2337075 9.22835389,43.2337075 Z"
              id="Stroke-3"
            ></path>
            <path
              d="M33.9598577,2.11038291 C29.2446026,4.10115772 20.5188479,10.9157762 20.5188479,10.9157762 L13.6419753,18.1734122 L24.4192294,30.4320988 L40.9259259,14.1043806 C40.9259259,14.1043806 35.0114852,1.66624385 33.9598577,2.11038291 Z"
              id="Stroke-5"
            ></path>
            <path
              d="M62.3584206,15.0341554 L67.1604938,16.4195142 C67.1604938,16.4195142 65.8936547,19.7700969 65.6227513,21.4871295 C65.35522,23.2052903 64.8246539,24.209337 63.5027348,25.5067006 C62.1808158,26.8040643 60.5992341,27.3884421 60.5992341,27.3884421 C60.5992341,27.3884421 58.1318767,25.2664063 54.7225395,26.5254132 C51.3132024,27.7855482 50.806242,31.0063945 50.806242,31.0063945 C50.806242,31.0063945 49.2235362,31.5907723 47.3789195,31.4632922 C45.535427,31.3358121 44.4821632,30.915015 43.1681128,29.7823601 C41.8540623,28.6508333 38.9123428,26.6889938 38.9123428,26.6889938 L41.4853638,22.7450082 C41.4853638,22.7450082 45.0127294,25.279944 44.839621,24.5398827 C44.1797855,21.7195268 38.0816471,5.62093574 33.5853238,2.02780241 C33.2155012,1.73222912 53.1679358,-0.120180591 54.9844504,0.00617134984 C57.858725,7.842248 59.6572543,15.0217458 60.9634363,18.5832911 C60.7026495,17.8714333 62.3584206,15.0341554 62.3584206,15.0341554 Z"
              id="Stroke-7"
            ></path>
            <path
              d="M84.9982097,56.7328212 C84.1937821,51.5299686 79.6692964,41.1560781 79.6692964,41.1560781 L74.274373,32.5308642 L59.8148148,40.4220657 L71.705575,60.8641975 C71.705575,60.8641975 85.1783389,57.8929244 84.9982097,56.7328212 Z"
              id="Stroke-9"
            ></path>
            <path
              d="M66.0282069,80.7263113 L63.6120951,85 C63.6120951,85 60.7285972,83.0146813 59.1625785,82.3621254 C57.5976595,81.7095694 56.7673617,80.9707433 55.8424868,79.407927 C54.9165123,77.8451107 54.7273583,76.1971303 54.7273583,76.1971303 C54.7273583,76.1971303 57.3051307,74.3257324 56.8949306,70.7753854 C56.4858302,67.2250384 53.5506448,65.9973483 53.5506448,65.9973483 C53.5506448,65.9973483 53.3603912,64.3493679 53.9058584,62.6151174 C54.4502258,60.8808669 55.0913697,59.9706066 56.466035,58.9751822 C57.8407003,57.9797578 60.3755831,55.617284 60.3755831,55.617284 L63.5208174,58.9873485 C63.5208174,58.9873485 60.3084995,61.7767489 61.049719,61.781173 C63.8738314,61.7999755 80.5292762,59.6775095 84.9677956,56.2045843 C85.3318069,55.9181233 82.5010962,75.4273354 81.9633271,77.1361473 C73.8769959,78.0784824 66.6616527,78.14595 62.9852478,78.5750886 C63.7209686,78.4888184 66.0282069,80.7263113 66.0282069,80.7263113 Z"
              id="Stroke-11"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

IconRecycle.defaultProps = {
  desc: 'Recyle Icon',
  height: 87,
  id: 'thredup-IconRecycle-icon',
  stroke: SPOT_BRAND,
  title: 'Recycle',
  width: 87
};

export { IconRecycle };
